import {CurrencyFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {MARGIN_DECIMALS} from '../constants/MARGIN_DECIMALS';
import {parseMarginAmount} from './parseMarginAmount';

/**
 * Margin amounts arrive as decimal strings and the string stays the source of truth. The
 * coercion lives in `parseMarginAmount`, purely so the value can be handed to the locale
 * formatter; every total comes precomputed from the backend.
 */
export function formatMarginAmount(
  amount: string | Nullish,
  currency: string,
  formatCurrency: CurrencyFormatter
) {
  const parsedAmount = parseMarginAmount(amount);

  if (isNil(parsedAmount)) {
    return EMPTY_PLACEHOLDER;
  }

  return formatCurrency(parsedAmount, currency, MARGIN_DECIMALS) ?? EMPTY_PLACEHOLDER;
}
